import * as React from 'react';

const PageNotFound: React.FC = () => {
	return <div className="page-not-found">
		<h1 className="page-not-found__header">404 Not Found</h1>
	</div>;
};

export default PageNotFound;
